import React from 'react'
import BannerImage from "../assets/BannerImage.jpg";
import AboutComponent from '../Components/AboutComponent'

import VissionComponent from '../Components/VissionComponent'
import Stats from '../Components/Stats'
import GetInTouch from '../Components/GetInTouch'
import { Link } from 'react-router-dom';

const About = () => {
  return (
    
    <>
        <div className='relative -z-50'>
            <div className="absolute w-full h-[300px]">
                <img src={BannerImage} alt="aboutImage" className="object-cover w-full h-[300px] opacity-95" />
            </div>
            <div className="relative flex  bg-gray-800 opacity-55">
                <div className="flex justify-start mx-12 items-center leading-8 w-full h-[300px]">
                    <h1 className=" font-bold text-5xl md:text-5xl text-white">About us</h1>
                     <span><Link className='text-white' to='/'>Home</Link></span> 
                </div>
            </div>
        </div>
        
    <AboutComponent />
    <VissionComponent />
    <Stats />
    <GetInTouch />
</>
  )
}

export default About